







import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class PersonalAttempt extends ViewBase {
  @Prop({ default: null }) personalAttempt!: any

  lang: any = {}

  echartSource: any = null

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  setSource() {
    const personalAttempt = this.personalAttempt
    const arr = []
    const textArr = []
    const index = 0
    for (const key of Object.keys(personalAttempt)) {
      // echarts绘制对象
      const obj: any = {}
      obj.product = personalAttempt[key].k_name
      obj.points_count = parseInt(personalAttempt[key].points_count, 10)
      obj.avg_points_count = parseInt(personalAttempt[key].avg_points_count, 10)
      arr.push(obj)
      this.echartSource = arr
    }
    this.setAttempt()
  }
  // 尝试次数
  setAttempt() {
    const that = this
    const myChart = echarts.init(this.$refs.attempt)
    const option = {
      legend: {
        x: 'center'
      },
      tooltip: {},
      dataset: {
        dimensions: ['product', 'points_count', 'avg_points_count'],
        source: that.echartSource
      },
      xAxis: {
        type: 'category',
        name: that.lang.xAxisText,
        nameLocation: 'center',
        nameTextStyle: { padding: 10 }
      },
      yAxis: { name: that.lang.personalAttemptNum, nameLocation: 'end' },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          barGap: 0,
          name: that.lang.personalAttemptNum,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#70AD47'
            }
          }
        },
        {
          name: that.lang.averageTimes,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#4472C4'
            }
          }
        }
      ]
    }

    // 绘制图表
    myChart.setOption(option)
  }
  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setSource()
    })
  }
}
